import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { useProjectDropList } from 'hooks/queries/common/commonDropListQuery';
import {
  useCurrencyDetail,
  useCharacterStandingDropList,
  useLiveWallpaperDropList,
  useCurrencyResourceDropList,
  useCurrencyIconDropList,
  useCurrencyInput,
} from 'hooks/queries/platform/currencyQuery';
import useLocalizingDropList from 'hooks/queries/common/useLocalizingDropList';
import useCurrencyTypeDropQuery from 'hooks/queries/common/useCurrencyTypeDropQuery';
import {
  ICharacterAbilityProps,
  ICurrencyDetailProps,
} from 'utils/types/platformTypes';
import DefaultLayout from 'components/layout/DefaultLayout';
import DefaultSelect from 'components/select/DefaultSelect';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import CurrencyLocalizingInput from './CurrencyLocalizingInput';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import DefaultButton from 'components/button/DefaultButton';
import DefaultInput from 'components/input/DefaultInput';
import ImageSelect from 'components/select/ImageSelect';
import CheckboxOneType from 'components/input/CheckboxOneType';
import CharacterAbilityList from 'pages/story/inAppProduct/dress/CharacterAbilityList';
import CurrencyBubbleInput from './CurrencyBubbleInput';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 재화 등록 & 수정
 */

const CurrencyInputPage = () => {
  const { t } = useTranslation();
  const { currencyId } = useParams();
  const navigate = useNavigate();
  const [langList, setLangList] = useState<any>([]);
  const [detailData, setDetailData] = useState<ICurrencyDetailProps>({
    currency: '',
    connected_project: -1,
    currency_type: '',
    is_unique: 0,
    consumable: 0,
    mission_reward: 0,
    is_use: 0,
    is_coin: 0,
    is_ability: 0,
    model_id: -1,
    local_code: -1,
    icon_image_id: -1,
    resource_image_id: -1,
    dev_name: '',
  });
  const [bubbleData, setBubbleData] = useState<any>([]); // 대사 데이터
  const [abilityData, setAbilityData] = useState<ICharacterAbilityProps[]>([]); // 능력치 데이터 (최대 2개)

  const { data: localizingData } = useLocalizingDropList(); // 다국어
  const { data: projectDropList } = useProjectDropList(); // 연결 작품
  const { data: currencyTypeDropList } = useCurrencyTypeDropQuery(); // 재화 타입
  const { data: standingDropList } = useCharacterStandingDropList(
    detailData?.connected_project,
  );
  const { data: liveWallpaperDropList } = useLiveWallpaperDropList(
    detailData?.connected_project,
  );
  const { data: currencyResourceDropList } = useCurrencyResourceDropList(
    detailData?.connected_project,
    detailData?.currency_type,
  );
  const { data: currencyIconDropList } = useCurrencyIconDropList(
    detailData?.connected_project,
  );

  const { data: currencyDetail, isFetching: currencyFetching } =
    useCurrencyDetail(currencyId!);
  const { mutate: currencyInput } = useCurrencyInput();

  /// 다국어 인풋 이벤트
  const handleLocalInputChange = (e) => {
    const { id, name, value } = e.target;
    setLangList(
      langList.map((v) => (v.code === id ? { ...v, [name]: value } : v)),
    );
  };
  /// 대사 인풋 이벤트
  const handleBubbleInputChange = (e) => {
    const { id, name, value } = e.target;
    setBubbleData(
      bubbleData?.map((v) => (v.code === id ? { ...v, [name]: value } : v)),
    );
  };

  /// 인풋 이벤트
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetailData({ ...detailData, [name]: value });
  };
  /// 드롭다운 이벤트
  const handleSelectChange = (val, option) => {
    setDetailData({ ...detailData, [option.name]: val });
  };

  /// 체크박스 이벤트
  const handleCheckProperty = (e) => {
    const { checked, name } = e.target;
    setDetailData({ ...detailData, [name]: checked ? 1 : 0 });
  };

  /// 서버 전송
  const handleSubmit = () => {
    const newObjLang: any = {};
    const newObjBubble: any = {};
    const keyName = '';

    langList?.map((v) => {
      newObjLang[keyName + Object.values(v)[0]] = Object.values(v)[2];
    });
    bubbleData?.map((v) => {
      newObjBubble[keyName + Object.values(v)[0]] = Object.values(v)[2];
    });

    console.log(abilityData);
    // ability_id가 -1인 것은 보내지 않는다.
    // 능력치가 없다면 [] 빈배열로 보낸다.
    const newAbility = abilityData.filter((v) => v.ability_id !== -1);
    console.log(newAbility);

    // console.log(newObjLang);
    // console.log(newObjBubble);
    currencyInput({
      newObjLang,
      newObjBubble,
      detailData,
      newAbility,
      currencyId,
    });
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  /// 수정 - 다국어 데이터만 따로 추출하기
  const isLangPreprocessing = () => {
    if (localizingData && currencyDetail) {
      const newArr: any = [];
      localizingData?.map((v, i) => {
        for (const [key, value] of Object.entries(currencyDetail.detail[0])) {
          if (v.value === key) {
            newArr.push({
              code: key,
              code_name: v.text,
              currencyName: value,
              key: i,
            });
          }
        }
      });

      // 대사(buuble)
      const newBubble: any = [];
      localizingData?.map((v, i) => {
        for (const [key, value] of Object.entries(currencyDetail.bubble[0])) {
          if (v.value === key) {
            newBubble.push({
              code: key,
              code_name: v.text,
              bubble: value,
              key: i,
            });
          }
        }
      });
      if (currencyDetail.ability.length <= 0) {
        setAbilityData([{ key: 0, ability_id: -1, add_value: 0, speaker: '' }]);
      } else {
        setAbilityData(
          currencyDetail.ability.map((v, i) => ({ ...v, key: i })),
        );
      }
      setDetailData(currencyDetail.detail[0]);
      setLangList(newArr);
      setBubbleData(newBubble);
    }
  };

  /// 등록일 때 초기 데이터, 다국어 세팅하기
  const isRegisterLangProcessing = () => {
    const newArr: any = [];
    const newBubble: any = [];
    localizingData?.map((v, i) => {
      newArr.push({
        code: v.value,
        code_name: v.text,
        currencyName: '',
        key: i,
      });
      newBubble.push({
        code: v.value,
        code_name: v.text,
        bubble: '',
        key: i,
      });
    });
    setLangList(newArr);
    setBubbleData(newBubble);
    setDetailData({
      currency: '',
      connected_project: -1,
      currency_type: '',
      is_unique: 0,
      consumable: 0,
      mission_reward: 0,
      is_use: 0,
      is_coin: 0,
      is_ability: 0,
      model_id: -1,
      local_code: -1,
      icon_image_id: -1,
      resource_image_id: -1,
      dev_name: '',
    });

    setAbilityData([{ key: 0, ability_id: -1, add_value: 0, speaker: '' }]);
  };

  useEffect(() => {
    if (currencyId === '0') {
      isRegisterLangProcessing();
    } else {
      isLangPreprocessing();
    }
  }, [currencyFetching]);
  return (
    <DefaultLayout>
      <SubmitFlexBox>
        <>
          <DefaultButton onClick={handleGoBack} style={{ marginRight: '1rem' }}>
            {t('currencyMasterID.headerButtons.listView')}
          </DefaultButton>
          <DefaultButton onClick={handleSubmit}>
            {t('currencyMasterID.headerButtons.save')}
          </DefaultButton>
        </>
      </SubmitFlexBox>
      <InputFlexBox style={{ marginTop: '2.5rem' }}>
        <InputWrappingBox left>
          <CurrencyLocalizingInput
            langList={langList}
            onChange={handleLocalInputChange}
          />
        </InputWrappingBox>
        <div style={{ width: '100%' }}>
          <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
            <DefaultSelect
              title={t('currencyMasterID.formTwo.connectionWorks')}
              name='connected_project'
              value={detailData?.connected_project}
              optionList={projectDropList}
              onChange={handleSelectChange}
            />
            <DefaultSelect
              title={t('currencyMasterID.formTwo.commodityType')}
              name='currency_type'
              value={detailData?.currency_type}
              optionList={currencyTypeDropList}
              onChange={handleSelectChange}
            />
            <DefaultInput
              title={t('currencyMasterID.formTwo.commodityID')}
              name='currency'
              value={detailData?.currency}
              onChange={handleInputChange}
              disabled={currencyId === '0' ? false : true}
              style={{ marginBottom: '0' }}
            />
            <Description>
              ※ {t('currencyMasterID.formTwo.commodityIDWarn')}
            </Description>
            <DefaultInput
              title={t('currencyMasterID.formTwo.nameForInternalUse')}
              name='dev_name'
              value={detailData?.dev_name}
              onChange={handleInputChange}
              style={{ marginBottom: '0' }}
            />
            <Description>
              ※ {t('currencyMasterID.formTwo.nameForInternalUseWarn')}
            </Description>
          </InputWrappingBox>
          {/* 대사 */}
          {detailData?.currency_type === 'bubble' && (
            <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
              <CurrencyBubbleInput
                bubbleData={bubbleData}
                onChange={handleBubbleInputChange}
              />
            </InputWrappingBox>
          )}
          {/* 캐릭터 */}
          {detailData?.currency_type === 'standing' && (
            <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
              <DefaultSelect
                title={t('currencyMasterID.formThree.characterModel')}
                name='model_id'
                value={detailData?.model_id}
                optionList={standingDropList}
                onChange={handleSelectChange}
              />
            </InputWrappingBox>
          )}
          {/* 배경 */}
          {detailData?.currency_type === 'wallpaper' && (
            <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
              <DefaultSelect
                title='Live 배경'
                name='model_id'
                value={detailData?.model_id}
                optionList={liveWallpaperDropList}
                onChange={handleSelectChange}
              />
            </InputWrappingBox>
          )}

          <>
            {detailData?.connected_project !== -1 &&
              detailData?.currency_type !== '' && (
                <>
                  <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
                    <InputFlexBox>
                      <>
                        {detailData?.currency_type !== 'sticker' &&
                          detailData?.currency_type !== 'badge' &&
                          detailData?.currency_type !== 'portrait' &&
                          detailData?.currency_type !== 'frame' && (
                            <ImageSelect
                              labelTitle={t('currencyMasterID.formFour.icon')}
                              name='icon_image_id'
                              value={detailData?.icon_image_id}
                              optionList={currencyIconDropList}
                              onChange={handleSelectChange}
                              style={{ marginRight: '1rem' }}
                            />
                          )}
                      </>
                      <ImageSelect
                        labelTitle={t('currencyMasterID.formFour.resource')}
                        name='resource_image_id'
                        value={detailData?.resource_image_id}
                        optionList={currencyResourceDropList}
                        onChange={handleSelectChange}
                      />
                    </InputFlexBox>
                  </InputWrappingBox>
                  <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
                    <SelectBoxWrapper>
                      <CheckboxWrap>
                        <h6>
                          {t('currencyMasterID.formFive.coinCommodityGood')}
                        </h6>
                        <CheckboxOneType
                          large
                          name='is_coin'
                          onChange={handleCheckProperty}
                          checked={detailData?.is_coin === 1 && true}
                        />
                      </CheckboxWrap>
                      <CheckboxWrap>
                        <h6>{t('currencyMasterID.formFive.missionReward')}</h6>
                        <CheckboxOneType
                          large
                          name='mission_reward'
                          onChange={handleCheckProperty}
                          checked={detailData?.mission_reward === 1 && true}
                        />
                      </CheckboxWrap>
                      <CheckboxWrap>
                        <h6>{t('currencyMasterID.formFive.usability')}</h6>
                        <CheckboxOneType
                          large
                          name='is_use'
                          onChange={handleCheckProperty}
                          checked={detailData?.is_use === 1 && true}
                        />
                      </CheckboxWrap>
                      <CheckboxWrap>
                        <h6>{t('currencyMasterID.formFive.consumable')}</h6>
                        <CheckboxOneType
                          large
                          name='consumable'
                          onChange={handleCheckProperty}
                          checked={detailData?.consumable === 1 && true}
                        />
                      </CheckboxWrap>
                      <CheckboxWrap>
                        <h6>{t('currencyMasterID.formFive.uniqueness')}</h6>
                        <CheckboxOneType
                          large
                          name='is_unique'
                          onChange={handleCheckProperty}
                          checked={detailData?.is_unique === 1 && true}
                        />
                      </CheckboxWrap>
                      <CheckboxWrap>
                        <h6>
                          {t('currencyMasterID.formFive.statAvailability')}
                        </h6>
                        <CheckboxOneType
                          large
                          name='is_ability'
                          onChange={handleCheckProperty}
                          checked={detailData?.is_ability === 1 && true}
                        />
                      </CheckboxWrap>
                    </SelectBoxWrapper>
                  </InputWrappingBox>
                  {detailData?.is_ability === 1 && (
                    <InputWrappingBox>
                      <CharacterAbilityList
                        abilityData={abilityData}
                        setAbilityData={setAbilityData}
                        projectId={detailData?.connected_project}
                      />
                    </InputWrappingBox>
                  )}
                </>
              )}
          </>
        </div>
      </InputFlexBox>
    </DefaultLayout>
  );
};

export default CurrencyInputPage;

const CheckboxWrap = styled.div`
  text-align: center;
  width: 5.5rem;
  h6 {
    font-weight: 500;
  }
`;

const Description = styled.p`
  font-size: 0.8rem;
  color: ${theme.colors.gray_2};
  margin-bottom: 1.2rem;
`;

const SelectBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;
`;
